export const practiceProblemsExperimentRegions = {
  right: [{ type: 'flagitem_button' }, { type: 'notepad_button' }],
  items: [
    {
      type: 'slider_element',
    },
  ],
};
